/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PlanDayResponse } from '../model';
/**
 * PlanCalendarControllerApi - axios parameter creator
 * @export
 */
export const PlanCalendarControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} partnerSlug 
         * @param {string} planSlug 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanCalendar: async (partnerSlug: string, planSlug: string, startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerSlug' is not null or undefined
            assertParamExists('listPlanCalendar', 'partnerSlug', partnerSlug)
            // verify required parameter 'planSlug' is not null or undefined
            assertParamExists('listPlanCalendar', 'planSlug', planSlug)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('listPlanCalendar', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('listPlanCalendar', 'endDate', endDate)
            const localVarPath = `/partners/{partnerSlug}/plans/{planSlug}/calendar`
                .replace(`{${"partnerSlug"}}`, encodeURIComponent(String(partnerSlug)))
                .replace(`{${"planSlug"}}`, encodeURIComponent(String(planSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserCalendar: async (startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('listUserCalendar', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('listUserCalendar', 'endDate', endDate)
            const localVarPath = `/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanCalendarControllerApi - functional programming interface
 * @export
 */
export const PlanCalendarControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanCalendarControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} partnerSlug 
         * @param {string} planSlug 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlanCalendar(partnerSlug: string, planSlug: string, startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanDayResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanCalendar(partnerSlug, planSlug, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserCalendar(startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanDayResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserCalendar(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlanCalendarControllerApi - factory interface
 * @export
 */
export const PlanCalendarControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanCalendarControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} partnerSlug 
         * @param {string} planSlug 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanCalendar(partnerSlug: string, planSlug: string, startDate: string, endDate: string, options?: any): AxiosPromise<Array<PlanDayResponse>> {
            return localVarFp.listPlanCalendar(partnerSlug, planSlug, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserCalendar(startDate: string, endDate: string, options?: any): AxiosPromise<Array<PlanDayResponse>> {
            return localVarFp.listUserCalendar(startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanCalendarControllerApi - object-oriented interface
 * @export
 * @class PlanCalendarControllerApi
 * @extends {BaseAPI}
 */
export class PlanCalendarControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} partnerSlug 
     * @param {string} planSlug 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanCalendarControllerApi
     */
    public listPlanCalendar(partnerSlug: string, planSlug: string, startDate: string, endDate: string, options?: AxiosRequestConfig) {
        return PlanCalendarControllerApiFp(this.configuration).listPlanCalendar(partnerSlug, planSlug, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanCalendarControllerApi
     */
    public listUserCalendar(startDate: string, endDate: string, options?: AxiosRequestConfig) {
        return PlanCalendarControllerApiFp(this.configuration).listUserCalendar(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}

